import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="relative overflow-hidden">
      <div className="absolute inset-0 bg-dot-pattern bg-dot opacity-15 pointer-events-none" />
      
      <div className="relative z-10 max-w-7xl mx-auto pt-16 pb-10 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 lg:gap-12">
          <div>
            <h3 className="text-[11px] font-semibold tracking-[0.15em] uppercase text-gray-400 mb-5">{t('footer.about.title')}</h3>
            <ul className="space-y-1 sm:space-y-3">
              <li><Link to="/about" className="block py-2.5 sm:py-0 text-gray-500 hover:text-gray-200 transition-colors duration-300 text-sm touch-manipulation">{t('footer.about.mission')}</Link></li>
              <li><Link to="/teams" className="block py-2.5 sm:py-0 text-gray-500 hover:text-gray-200 transition-colors duration-300 text-sm touch-manipulation">{t('footer.about.teams')}</Link></li>
              <li><Link to="/careers" className="block py-2.5 sm:py-0 text-gray-500 hover:text-gray-200 transition-colors duration-300 text-sm touch-manipulation">{t('footer.about.join')}</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-[11px] font-semibold tracking-[0.15em] uppercase text-gray-400 mb-5">{t('footer.services.title')}</h3>
            <ul className="space-y-1 sm:space-y-3">
              <li><Link to="/info" className="block py-2.5 sm:py-0 text-gray-500 hover:text-gray-200 transition-colors duration-300 text-sm touch-manipulation">{t('nav.forum')}</Link></li>
              <li><Link to="/education" className="block py-2.5 sm:py-0 text-gray-500 hover:text-gray-200 transition-colors duration-300 text-sm touch-manipulation">{t('nav.education')}</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-[11px] font-semibold tracking-[0.15em] uppercase text-gray-400 mb-5">{t('footer.moreServices.title')}</h3>
            <ul className="space-y-1 sm:space-y-3">
              <li><Link to="/aid" className="block py-2.5 sm:py-0 text-gray-500 hover:text-gray-200 transition-colors duration-300 text-sm touch-manipulation">{t('nav.community')}</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-[11px] font-semibold tracking-[0.15em] uppercase text-gray-400 mb-5">{t('footer.follow.title')}</h3>
            <div className="flex flex-wrap gap-3">
              <a href="https://www.linkedin.com/company/chinese-community-ai" className="w-9 h-9 rounded-lg bg-dark-surface border border-dark-border flex items-center justify-center text-gray-500 hover:text-white hover:border-dark-border-light transition-all duration-300" rel="noopener noreferrer" target="_blank" title="LinkedIn">
                <Linkedin className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[13px] text-gray-600">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
          <div className="flex flex-wrap justify-center md:justify-end gap-x-6 gap-y-1 text-[13px] text-gray-600">
            <p>{t('footer.tagline.vision')}</p>
            <p>{t('footer.tagline.mission')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
